import { useAppStore } from '@/app-context'
import { ContentWrapper } from '@/common/styles/page.css'
import MetaTag from '@/components/MetaTag'
import { ELanguage } from '@microfrontends/react-components'
import dynamic from 'next/dynamic'
import React from 'react'

const ContentEN = dynamic(() => import('./content.en'))
const ContentVI = dynamic(() => import('./content.vi'))

const OperationEcommercePage = () => {
    const { props } = useAppStore()
    
    const pageTitle = props.langCode === ELanguage.VI ? 'QUY CHẾ HOẠT ĐỘNG WEBSITE/ỨNG DỤNG CUNG CẤP DỊCH VỤ TMĐT VIETNAMWORKS.' : 'OPERATION REGULATION OF WEBSITE PROVIDING E-COMMERCE TRADING SERVICE ON WEBSITE/APPLICATION WWW.VIETNAMWORKS.COM'

    return (
        <>
            <MetaTag title={pageTitle} description={pageTitle} isIndex />
            <ContentWrapper>
                {props.langCode === ELanguage.VI ? <ContentVI /> : <ContentEN />}
            </ContentWrapper>
        </>
    )
}

export default OperationEcommercePage
